import type { StyleProp, ViewStyle } from 'react-native';

import { getStyleSheet } from './style-sheet-memo';

export const pr = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ paddingRight: padding });

export const pl = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ paddingLeft: padding });

export const pt = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ paddingTop: padding });

export const pb = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ paddingBottom: padding });

export const pv = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ paddingVertical: padding });

export const ph = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ paddingHorizontal: padding });

export const padding = (padding: number | string): StyleProp<ViewStyle> =>
  getStyleSheet({ padding });
